import { render, staticRenderFns } from "./FeedProductTabBar.vue?vue&type=template&id=3e5efa10&"
import script from "./FeedProductTabBar.vue?vue&type=script&lang=ts&"
export * from "./FeedProductTabBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports